import React from "react";

export default function ServiceUnavailable({ onRetry }) {
  return (
    <div className="container">
      <div className="logo-wrapper">
        <img
          src="https://superkos.id/wp-content/uploads/2023/10/SuperKos_Logo-1024x261.png.webp"
          alt="SuperKos"
          loading="eager"
        />
      </div>

      <div className="card">
        <span className="badge">Sedang Diproses</span>

        <h1>Hmm…</h1>

        <h2>Sedang Menyiapkan Informasi</h2>

        <p>
          Kami sedang menyiapkan informasi terbaru untuk Anda.
          <br />
          Silakan coba lagi dalam beberapa saat.
        </p>

        <div className="actions">
          <button className="button primary" onClick={onRetry}>
            Coba Lagi
          </button>

          <a
            href="https://wa.me/6281382586868"
            target="_blank"
            rel="noopener noreferrer"
            className="button secondary"
          >
            Hubungi Bantuan
          </a>
        </div>
      </div>

      <footer>
        © {new Date().getFullYear()} Superkos · Aplikasi Manajemen Kos
      </footer>

      <style jsx>{`
        .container {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 24px;
          background: linear-gradient(180deg, #f0fdf4, #f8fafc);
          font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI",
            Roboto, Ubuntu;
          color: #0f172a;
        }

        .logo-wrapper {
          margin-bottom: 20px;
        }

        .logo-wrapper img {
          height: 40px;
          max-width: 220px;
          object-fit: contain;
        }

        .card {
          max-width: 520px;
          width: 100%;
          background: linear-gradient(180deg, #ffffff, #f8fafc);
          border: 1px solid #e2e8f0;
          border-radius: 20px;
          padding: 40px 32px;
          box-shadow: 0 20px 40px rgba(15, 23, 42, 0.08);
          text-align: center;
        }

        .badge {
          display: inline-block;
          padding: 6px 14px;
          border-radius: 999px;
          font-size: 13px;
          font-weight: 600;
          background: linear-gradient(90deg, #fde68a, #facc15);
          color: #854d0e;
          margin-bottom: 16px;
        }

        h1 {
          font-size: 56px;
          margin: 12px 0;
          letter-spacing: -1px;
        }

        h2 {
          font-size: 20px;
          margin-bottom: 12px;
          font-weight: 600;
        }

        p {
          color: #64748b;
          line-height: 1.6;
          margin-bottom: 28px;
        }

        .actions {
          display: flex;
          gap: 12px;
          justify-content: center;
          flex-wrap: wrap;
        }

        .button {
          padding: 12px 20px;
          border-radius: 12px;
          font-weight: 600;
          font-size: 14px;
          cursor: pointer;
          border: none;
          text-decoration: none;
          transition: all 0.2s ease;
        }

        .primary {
          background: linear-gradient(90deg, #fccb06, #ffdfa3);
          color: #020617;
        }

        .primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(252, 203, 6, 0.35);
        }

        .secondary {
          background: transparent;
          border: 1px solid #d5dcf1;
          color: #0f172a;
        }

        .secondary:hover {
          background: #020617;
          color: #f0fdf4;
        }

        footer {
          margin-top: 20px;
          font-size: 12px;
          color: #64748b;
          text-align: center;
        }

        @media (max-width: 480px) {
          h1 {
            font-size: 44px;
          }
          .card {
            padding: 32px 20px;
          }
        }
      `}</style>
    </div>
  );
}